import { useRecordContext } from "react-admin";

export const OpenSearchTitle = () => {
  const record = useRecordContext();

  console.log("record", record);

  return 123;
};
